import { ChangePasswordFormActionsProps } from './types';

export const ChangePasswordFormActions = ({ children }: ChangePasswordFormActionsProps) => <div className="flex gap-4 flex-wrap">{children}</div>;
